import React, { useState, useEffect, useCallback, useRef } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import { useSelector } from 'react-redux';
// importando os services
import api from '~/services/api';
// import history from '~/services/history';

// Componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Select from '~/components/Form/Select';

import { Container, InputDate, Label } from './styles';

export default function LeadNew() {
  const inputRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [carregar, setCarregar] = useState(false);
  const [agendamento, setAgendamento] = useState(new Date());
  const [timesSelect, setTimesSelect] = useState([]);
  const [userSelect, setUserSelect] = useState([]);
  const user = useSelector(state => state.user.profile);
  const canalOptions = [
    {
      label: 'ig',
      value: 'ig',
    },
    {
      label: 'fb',
      value: 'fb',
    },
    {
      label: 'lp',
      value: 'lp',
    },
    {
      label: 'bot',
      value: 'bot',
    },
    {
      label: 'cms',
      value: 'cms',
    },
    {
      label: 'ig',
      value: 'ig',
    },
    {
      label: 'telefone',
      value: 'telefone',
    },
    {
      label: 'mailing',
      value: 'mailing',
    },
    {
      label: 'wp',
      value: 'wp'
    }
  ];

  // Buscando os dados da api
  const getProducts = useCallback(async () => {
    const response = await api.get('/produto-select');
    const data = response.data.map(res => {
      return {
        label: res.name,
        value: res.id,
      };
    });
    setProducts(data);
  }, []);

  const getTimes = useCallback(async () => {
    if (user.provider === '4') {
      const responseTime = await api.get('times-select');
      const data = responseTime.data.map(res => {
        return {
          value: res.id,
          label: res.name,
        };
      });
      setTimesSelect(data);
    }
  }, [user]);

  useEffect(() => {
    getProducts();
    getTimes();
  }, [getProducts, getTimes]);

  async function handlerSubmit(data, { reset }) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      let schema;

      if (user.provider === '4') {
        schema = Yup.object().shape({
          product_id: Yup.string('Selecione um produto').required(
            'Selecione um produto'
          ),
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string('Informe um e-mail valido').required(
            'Preencha o campo email'
          ),
          telefone: Yup.string()
            .min(10, 'No mínimo 10 caracteres')
            .max(11, 'No máximo 11 caracteres')
            .required('Preencha o campo telefone'),
          canal: Yup.string('Selecione um canal').required(
            'Selecione um canal'
          ),
          time_id: Yup.string('Selecione um time').required(
            'Selecione um time'
          ),
          user_id: Yup.string('Selecione um usuario').required(
            'Selecione um usuario'
          ),
        });
      } else {
        schema = Yup.object().shape({
          product_id: Yup.string('Selecione um produto').required(
            'Selecione um produto'
          ),
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string('Informe um e-mail valido').required(
            'Preencha o campo email'
          ),
          telefone: Yup.string()
            .min(10, 'No mínimo 10 caracteres')
            .max(11, 'No máximo 11 caracteres')
            .required('Preencha o campo telefone'),
          canal: Yup.string('Selecione um canal').required(
            'Selecione um canal'
          ),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/lead-manual', {
        produto_id: data.product_id,
        name: data.name,
        email: data.email,
        telefone: data.telefone,
        data_atendimento: agendamento,
        canal: data.canal,
        user_id: data.user_id ? data.user_id : null,
      });

      toast.success('Lead cadastrado com sucesso');

      // reset();
      // history.push('/leads');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o lead verifique o produto');
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleFiltarUser(e) {
    const response = await api.post('filtrar-users', {
      time_id: e.value,
    });

    const data = response.data.map(res => {
      return {
        value: res.id,
        label: res.name,
      };
    });

    setUserSelect(data);
  }

  return (
    <Container>
      <h4>Cadastro de leads</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Select name="product_id" labelSelect="Produtos" options={products} />
          <Input icon="MdPerson" name="name" label="Nome" type="text" />
          <Input icon="MdMail" name="email" label="E-mail" type="email" />
          <Input
            icon="MdPhone"
            name="telefone"
            label="Telefone"
            type="number"
          />
          <Select name="canal" labelSelect="Canal" options={canalOptions} />
          {user.provider === '4' && (
            <Select
              name="time_id"
              labelSelect="Selecione o time"
              options={timesSelect}
              onChange={handleFiltarUser}
            />
          )}
          {userSelect.length > 0 && (
            <Select
              name="user_id"
              labelSelect="Selecione o usuario"
              options={userSelect}
            />
          )}
          <Label>
            <p>Data de agendamento de retorno</p>
            <InputDate
              selected={agendamento}
              onChange={date => setAgendamento(date)}
              locale="pt-BR"
              minDate={new Date()}
              timeFormat="HH:mm"
              showTimeSelect
              dateFormat="d/MM/yyyy HH:mm"
              es
            />
          </Label>
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
